import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap } from "rxjs";
import { API } from "src/app/common/models/api.enum";
import { CommonApiService } from "src/app/services/common-api.service";
import { decryptData } from "src/app/common/functions/crypto.functions";
import { FlowListResponse } from "src/app/common/models/interaction/flow.model";
import {
  fetchFlowList,
  fetchFlowListFailed,
  fetchFlowListSuccess,
} from "./flow-list-actions";

@Injectable()
export class FlowListEffects {
  private actions = inject(Actions);
  private commonApiService = inject(CommonApiService);

  fetchFlowList$ = createEffect(() => {
    return this.actions.pipe(
      ofType(fetchFlowList),
      switchMap(() => {
        const agentId = this.getAgentId();
        if (!agentId) {
          return of(fetchFlowListFailed({ error: "Invalid Agent ID" }));
        }
        let quaryParams = 
        {
          language: sessionStorage.getItem("lang"),
        }
        return this.commonApiService
          .get<
            FlowListResponse[]
          >(API.FETCH_FLOW_LIST.replace("{{ botId }}", agentId),quaryParams)
          .pipe(
            map((response) => {
              return fetchFlowListSuccess({ flows: response || [] });
            }),
            catchError((error) => {
              const errorMessage =
                error?.message || "Failed to fetch flow list";
              return of(fetchFlowListFailed({ error: errorMessage }));
            }),
          );
      }),
    );
  });

  private getAgentId(): string {
    const encrypted = sessionStorage.getItem("aiag");
    if (!encrypted) return "";
    try {
      return decryptData(encrypted);
    } catch {
      return "";
    }
  }
}
